<template>
  <TextField
    id="mealplan-operator-password"
    :name="`${formNamespace}keystore.operator_password`"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.operatorPassword')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.operatorPasswordPlaceholder')"
    :required="editMealPlan"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
const formNamespace = inject('formNamespace', '');
</script>
